import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  showPassword = false;
  showConfirmPassword = false;
  phone: string | null = null;
  otpCode: string | null = null;
  isLoading = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService
  ) {
    this.resetForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    // URL-den phone ve code-u oxu
    this.route.queryParams.subscribe(params => {
      this.phone = params['phone'];
      this.otpCode = params['code'];
      if (!this.phone || !this.otpCode) {
        this.errorMessage = 'Etibarsız və ya çatışmayan məlumat. Zəhmət olmasa yenidən cəhd edin.';
      }
    });
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('password')?.value === g.get('confirmPassword')?.value
      ? null : { 'mismatch': true };
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  onSubmit(): void {
    if (this.resetForm.valid && this.phone && this.otpCode) {
      this.isLoading = true;
      this.errorMessage = null;
      this.successMessage = null;

      const resetData = {
        phone: this.phone,
        otpCode: this.otpCode,
        newPassword: this.resetForm.value.password,
        confirmPassword: this.resetForm.value.confirmPassword
      };

      this.auth.resetPassword(resetData).subscribe({
        next: () => {
          this.isLoading = false;
          this.successMessage = 'Şifrəniz uğurla yeniləndi. Giriş səhifəsinə yönləndirilirsiniz...';
          setTimeout(() => this.router.navigate(['/login']), 3000);
        },
        error: (err) => {
          this.isLoading = false;
          const errorObj = err.error?.error || err.error;
          const errorCode = errorObj?.code;
          const errorDetails = errorObj?.details;
          this.errorMessage = errorDetails || (errorCode ? this.auth.getAlertService().getErrorMessage(errorCode) : 'Şifrəni yeniləyərkən xəta baş verdi.');
          console.error('Reset password error:', err);
        }
      });
    } else if (!this.phone || !this.otpCode) {
      this.errorMessage = 'Zəruri məlumatlar tapılmadı. Şifrəni yeniləmək mümkün deyil.';
    } else {
      this.resetForm.markAllAsTouched();
    }
  }
}
